import createStore from './store';

const captionsRequireUpdate = createStore<Record<string, boolean>>({});
export const markCaptionsObsolete = ({ clipId }: { clipId: string }) => {
  captionsRequireUpdate.update(data => ({
    ...data,
    [clipId]: true
  }));
};

export const markCaptionsUpdated = ({ clipId }: { clipId: string }) => {
  captionsRequireUpdate.update(data => ({
    ...data,
    [clipId]: false
  }));
};

export const areCaptionsObsolete = (clipId: string) => {
  return captionsRequireUpdate.getSnapshot()[clipId] || false;
};
